import BaseRepository from "@/services/resources/repository";
import byProgrammeArea from "@/services/resources/mixins/query-by-programme-area";
import byKeyword from "@/services/resources/mixins/query-by-keyword";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(byProgrammeArea).$mix(byKeyword);
    }
}

export default Repository;
